import React, { useEffect, useRef, useState } from 'react';
import { FiSearch, FiLink, FiX } from 'react-icons/fi';
import backofficeService from '../../../services/backofficeService';

const SEARCHABLE = ['futebol', 'tenis'];
const STATE_LABEL = { in: 'Ao vivo', post: 'Terminado' };

/* Search ESPN fixtures for the game's date and pick one to fill the form.
   Optional: games can still be typed by hand (they're then matched by name). */
function GamePicker({ game, onPick, onUnlink }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const boxRef = useRef(null);
  const searchable = SEARCHABLE.includes(game.sport);

  // Debounced search on the game's date and sport
  useEffect(() => {
    if (!open || !searchable || !game.date) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      setError('');
      try {
        const events = await backofficeService.searchEspnGames({ date: game.date, sport: game.sport, q: query });
        if (!cancelled) setResults(events);
      } catch (e) {
        if (!cancelled) setError('Não foi possível pesquisar jogos.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 300);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query, open, searchable, game.date, game.sport]);

  useEffect(() => {
    const onClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  if (game.espn_event_id) {
    return (
      <div className="gp-linked">
        <FiLink className="gp-linked-icon" />
        <span>
          Ligado ao jogo da ESPN: o resultado ao vivo aparece na aposta
        </span>
        <button type="button" className="gp-unlink" onClick={onUnlink} title="Desligar">
          <FiX /> Desligar
        </button>
      </div>
    );
  }

  if (!searchable) {
    return <p className="gp-hint">A pesquisa de jogos está disponível para futebol e ténis. Preenche os campos à mão.</p>;
  }

  const pick = (event) => {
    onPick(event);
    setOpen(false);
    setQuery('');
  };

  return (
    <div className="gp" ref={boxRef}>
      <div className="gp-input">
        <FiSearch className="gp-input-icon" />
        <input
          type="text"
          value={query}
          onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder={`Procurar jogo de ${game.date ? game.date.split('-').reverse().join('/') : 'hoje'} (ex: Benfica) — ou preenche à mão`}
        />
      </div>

      {open && (
        <div className="gp-results">
          {loading && <div className="gp-status">A procurar…</div>}
          {!loading && error && <div className="gp-status is-error">{error}</div>}
          {!loading && !error && results.length === 0 && (
            <div className="gp-status">
              Nenhum jogo encontrado neste dia. Confirma a data do jogo ou preenche os campos à mão.
            </div>
          )}
          {!loading && !error && results.map(ev => (
            <button key={ev.id} type="button" className="gp-result" onClick={() => pick(ev)}>
              <span className="gp-time">{ev.time}</span>
              <span className="gp-teams">
                {ev.home} <span className="gp-vs">–</span> {ev.away}
                {ev.tournament && <span className="gp-tournament">{ev.tournament}</span>}
              </span>
              {STATE_LABEL[ev.state] && <span className={`gp-state is-${ev.state}`}>{STATE_LABEL[ev.state]}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default GamePicker;
